module.exports = __webpack_public_path__ + "static/media/219401067_kit.aea6bb7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/219401067_kit.png
// module id = 483
// module chunks = 0